import { useEffect, useState } from 'react'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { IDiscountCode } from '../typings'

export const useGetDiscountCodeOnMount = (id: string | null) => {
  const [discountCode, setDiscountCode] = useState<IDiscountCode>()

  const [loadingStatus, setLoadingStatus] = useState<
    'pending' | 'failure' | 'success'
  >()

  useEffect(() => {
    const baseUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.discountCode.discountCode}`
    const execute = async () => {
      if (id) {
        try {
          setLoadingStatus('pending')
          const response = await get(`${baseUrl}/${id}`)
          if (response.ok) {
            const code: IDiscountCode = await response.json()
            setDiscountCode(code)
          }
        } catch (error) {
          console.error(error)
          setLoadingStatus('failure')
        } finally {
          setLoadingStatus('success')
        }
      } else {
        setDiscountCode(undefined)
      }
    }
    execute()
  }, [id])

  return { discountCode, loadingStatus }
}
